import { MouseEventHandler } from 'react';
import styled from './NextButton.module.scss'

interface Props {
  children: any;
  onClick: Function
}

const NextButton = ({
  children,
  onClick
}: Props) => {
  return (
    <button className={styled.wrapper} onClick={onClick as MouseEventHandler<HTMLButtonElement>}>
      {children}
    </button>
  )
}

export default NextButton